import {DeflyWalletConnect} from "@blockshake/defly-connect";

import {getChainId} from "../algosdk/algodHelpers";

interface DeflyConnectEventHandlers {
  onDisconnect: () => Promise<void>;
}

class DeflyConnect extends DeflyWalletConnect {
  connectAndSetupEventHandlers(handlers: DeflyConnectEventHandlers): Promise<string[]> {
    return new Promise((resolve, reject) => {
      super
        .connect()
        .then((data) => {
          this.setupEventHandlers(handlers);
          resolve(data);
        })
        .catch((error) => {
          if (error.data.type === "CONNECT_MODAL_CLOSED") {
            return;
          }
          reject(error);
        });
    });
  }

  reconnectSessionAndSetupEventHandlers(
    handlers: DeflyConnectEventHandlers
  ): Promise<string[]> {
    const promise = super.reconnectSession();

    promise
      .then(() => {
        this.setupEventHandlers(handlers);

        // If the connector somehow disconnects (could be network issue), we reset the account data
        if (!this.isConnected) {
          handlers.onDisconnect();
        }
      })
      .catch((error) => {
        console.log(error.data);
      });

    return promise;
  }

  private setupEventHandlers({onDisconnect}: DeflyConnectEventHandlers) {
    this.connector?.on("disconnect", () => {
      // For some reason, when we pass the `disconnectAccount` directly as the callback, it doesn't work
      onDisconnect();
    });
  }
}

const deflyWalletManager = new DeflyConnect({
  shouldShowSignTxnToast: false,
  chainId: getChainId()
});

export default deflyWalletManager;
